module.exports = __webpack_public_path__ + "img/football-helmet.101a7422.png";